<div class="headrules">
    <h1>Основные правила проекта</h1>
</div>
<div class="rulesblockbg">
    <h1>Положение об аккаунте и персонаже</h1>
    <p><strong>Положение об аккаунте:</strong></p>

    <p>1. Максимальное количество разрешенных аккаунтов на одного человека - один. <b>| Блокировка всех аккаунтов на 30 дней / PermBan.</b></p>
    
    <p>2. Запрещено передавать аккаунт 3-м лицам. <b>| PermBan.</b></p>
    
    <p>3. Администрация не несет ответственности за аккаунт игрока в случае его передачи, взлома, обмана и т.д.</p>
    
    <p>4. Запрещена продажа / обмен игровых аккаунтов. <b>| PermBan.</b></p>
    
    <p>5. Запрещено одновременно состоять несколькими персонажами во фракции / семье. <b>| WARN персонажей.</b><br>
    <b>Исключение:</b> при покупке третьего персонажа можно вступать в две фракции / семьи (все три персонажа должны быть созданы).<br>
    <b>Пояснение:</b> какой именно персонаж находится во фракции / семье (1 и 3, 2 и 3, либо 1 и 2) не имеет никакого значения.<br>
    <b>Примечание:</b> запрещено находится на старших / руководящих рангах в обеих фракциях.</p>
    
    <p>6. Ограничения по участию в различного рода мероприятиях накладываются на персонажа, вне зависимости от его фракции/семьи. <b>| WARN / HardBan 7 дней.</b><br>
    <b>Пример:</b> игрок А находясь в семье и фракции не может участвовать 4 раза в перехвате поставки, лимит нападений для игрока А составляет 2, вне зависимости от того нападает он с фракцией или с семьей.</p>
    
    <p><strong>Положение об игровом имуществе:</strong></p>
    
    <p>7. Запрещено владеть имуществом без игровой активности. <b>| Изъятие имущества.</b><br>
    <b>Игровая активность</b> - это активность персонажа, которая присуща каждому игроку во время игры (перестрелки, игровые покупки, игра в азартные игры и т.п.)<br>
    <b>Игровой активностью не считается:</b><br>
    Оплата налогов<br>
    Оплата заказов<br>
    АФК<br>
    Езда на автомобиле без конкретных целей (езда по кругу, чтоб начислялось зарплата, чтоб сделать видимость игровой активности и т.п.)<br>
    Для сохранения своего имущества необходимо минимум 1-2 часа в день игровой активности (либо более продолжительное время в другие дни, при отсутствия возможности игры).<br>
    Минимальная активность в неделю - 4 часа, в месяц - 30 часов.<br>
    <b>Исключение:</b> решение ГА; в случае возникновения уважительных причин отсутствия активности возможно предупреждение ГА, с дальнейшим исключением и не изъятием имущества (только при одобрении и согласовании с ГА сервера).</p>
    
    <p>8. Запрещено иметь более 1 бизнеса на аккаунте. <b>| Изъятие бизнесов.</b></p>
    
    <p>9. Персонажу запрещено иметь nonRP "Имя Фамилия", к nonRP никнеймам относятся:<br>
    Имена, которых не существует в реальности или имеющие несуразное звучание.<br>
    Имена, похожие на ники администраторов.<br>
    Никнеймы несущие в себе скрытый смысл / звучание.<br>
    Любые Имена / Фамилии политических деятелей, а также людей как-либо связанных с политической активностью.<br>
    За подобный ряд никнеймов выдается demorgan до смены никнейма.<br>
    В случае попадания в demorgan более 3 раз за nonRP nickname, игроку выдается demorgan 120 минут.<br>
    Главный администратор сервера имеет право отклонить никнейм без каких-либо обоснований или пояснений.</p>
    
    <p>10. Запрещено играть за персонажа противоположного Вам пола. <b>| Demorgan до смены внешности персонажа.</b></p>
</div>